import { render, staticRenderFns } from "./UnmappedSusaTable.vue?vue&type=template&id=79e3924a&scoped=true"
import script from "./UnmappedSusaTable.vue?vue&type=script&lang=js"
export * from "./UnmappedSusaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e3924a",
  null
  
)

export default component.exports